var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLocalPostOfficeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2871_20402",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2871_20402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 27.5C3.89583 27.5 3.59896 27.3802 3.35938 27.1406C3.11979 26.901 3 26.6042 3 26.25V16.25C3 15.8958 3.11979 15.599 3.35938 15.3594C3.59896 15.1198 3.89583 15 4.25 15H8V10C8 7.91667 8.72917 6.14583 10.1875 4.6875C11.6458 3.22917 13.4167 2.5 15.5 2.5H20.5C22.5833 2.5 24.3542 3.22917 25.8125 4.6875C27.2708 6.14583 28 7.91667 28 10V26.25C28 26.6042 27.8802 26.901 27.6406 27.1406C27.401 27.3802 27.1042 27.5 26.75 27.5C26.3958 27.5 26.099 27.3802 25.8594 27.1406C25.6198 26.901 25.5 26.6042 25.5 26.25V23.75H20.5V26.25C20.5 26.6042 20.3802 26.901 20.1406 27.1406C19.901 27.3802 19.6042 27.5 19.25 27.5H4.25ZM11.75 21.0625L6.90625 18.3125C6.59375 18.125 6.28125 18.125 5.96875 18.3125C5.65625 18.5 5.5 18.7708 5.5 19.125C5.5 19.2917 5.54167 19.4531 5.625 19.6094C5.70833 19.7656 5.82292 19.8854 5.96875 19.9688L11.125 22.9062C11.3125 23.0104 11.5208 23.0625 11.75 23.0625C11.9792 23.0625 12.1875 23.0104 12.375 22.9062L17.5312 19.9688C17.6771 19.8854 17.7917 19.7656 17.875 19.6094C17.9583 19.4531 18 19.2917 18 19.125C18 18.7708 17.8438 18.5 17.5312 18.3125C17.2188 18.125 16.9062 18.125 16.5938 18.3125L11.75 21.0625ZM20.5 21.25H25.5V10C25.5 8.625 25.0104 7.44792 24.0312 6.46875C23.0521 5.48958 21.875 5 20.5 5H15.5C14.125 5 12.9479 5.48958 11.9688 6.46875C10.9896 7.44792 10.5 8.625 10.5 10V15H19.25C19.6042 15 19.901 15.1198 20.1406 15.3594C20.3802 15.599 20.5 15.8958 20.5 16.25V21.25ZM14.25 12.5C13.8958 12.5 13.599 12.3802 13.3594 12.1406C13.1198 11.901 13 11.6042 13 11.25C13 10.8958 13.1198 10.599 13.3594 10.3594C13.599 10.1198 13.8958 10 14.25 10H21.75C22.1042 10 22.401 10.1198 22.6406 10.3594C22.8802 10.599 23 10.8958 23 11.25C23 11.6042 22.8802 11.901 22.6406 12.1406C22.401 12.3802 22.1042 12.5 21.75 12.5H14.25Z",
    fill: "#ADBBCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocalPostOfficeGrey);
export default __webpack_public_path__ + "static/media/icon_local_post_office_grey.627f8d9b5b70412662cc4d1e90eb23f6.svg";
export { ForwardRef as ReactComponent };